import { render, staticRenderFns } from "./company-title.vue?vue&type=template&id=65a19f84&scoped=true&"
import script from "./company-title.vue?vue&type=script&lang=js&"
export * from "./company-title.vue?vue&type=script&lang=js&"
import style0 from "./company-title.vue?vue&type=style&index=0&id=65a19f84&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a19f84",
  null
  
)

export default component.exports